import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { LanguageService } from '@shared/language/language.service';
import { AppConfigService } from './app.config.service';

export const ICON_NAME = 'iconset';
export const LANGUAGE_NAME = 'language';

@Injectable()
export class AppService {
  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _appConfService: AppConfigService,
    private _languageService: LanguageService
  ) {
    // Establish observation for configuration changes
    this._appConfService.configuration().subscribe((config: any) => {
      if (typeof config !== 'undefined') {
        // Language configuration
        if (config.hasOwnProperty(LANGUAGE_NAME)) {
          this._languageService.configure(config[LANGUAGE_NAME]);
        }
        // Icons set configuration
        if (config.hasOwnProperty(ICON_NAME)) {
          this._iconRegistry.addSvgIconSet(
            this._sanitizer.bypassSecurityTrustResourceUrl(config[ICON_NAME])
          );
        }
      }
    });
  }
}
